/**
 * @link https://mui.com/material-ui/react-card/
 */

import * as React from 'react';
import {
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
} from '@mui/material';
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeCard() {
  return (
    <>
      <Card sx={{ minWidth: 275 }}>
        <CardContent>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Word of the Day
          </Typography>
          <Typography variant="h5" component="div">
            Facturee
          </Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            Der Online-Fertiger
          </Typography>
          <Typography variant="body2">
            We understand how
            <br />
            production works these days.
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small">Learn More</Button>
        </CardActions>
      </Card>
      
      <ShowCode 
        codeString={`function CardExample() {
  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Word of the Day
        </Typography>
        <Typography variant="h5" component="div">
          Facturee
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          Der Online-Fertiger
        </Typography>
        <Typography variant="body2">
          We understand how
          <br />
          production works these days.
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions>
    </Card>
  );
}`} 
        scope={{ 
          React, 
          Card, 
          CardActions, 
          CardContent, 
          Button, 
          Typography 
        }} 
      />
    </>
  );
}